import ReactECharts from "echarts-for-react";

type AppProps = {
  data: any;
  yAxisName: string;
  xAxisName: string;
  pre_data: boolean | null;
  activeTab: string;
  currency:string | undefined;
  changeYear: boolean;
  selectYear?: string | null | undefined;
  compareTo?: string | null | undefined;
};
const DataGraph = ({
  data,
  yAxisName,
  xAxisName,
  pre_data,
  activeTab,
  changeYear,
  selectYear,
  currency,
  compareTo,
}: AppProps) => {
  const dateList = data?.data?.map(function (item: any) {
    return item.month;
  });
  const dateList1 = data?.Previous_data?.map(function (item: any) {
    return item.month;
  });

  const valueList = data?.data?.map(function (item: any) {
    return item.total_amount;
  });

  const valueList1 = data?.Previous_data?.map(function (item: any) {
    return item.total_amount;
  });

  const option = {
    visualMap: [
      {
        show: false,
        type: "continuous",
      },
    ],

    tooltip: {
      trigger: "axis",
    },

    grid: {
      bottom: "20%",
      left: Math.max(...valueList) > 150000 ? "20%" : "12%",
      right: "5%",
    },
    xAxis: [
      {
        // data: (Pre_data && changeYear) || changeYear ? dateList : dateList1,
        data:
          dateList?.length === 0
            ? dateList1
            : pre_data
            ? dateList1
            : changeYear
            ? dateList
            : dateList1,

        name: xAxisName,
        boundaryGap: false,
        nameLocation: "middle",
        nameTextStyle: {
          width: 100,
          color: "#4e4b66",
          fontSize: "14px",
        },
        nameGap: 30,
      },
    ],

    yAxis: [
      {
        type: "value",
        axisLabel: {
          formatter: `${currency} {value}` ,
          // format: 'short'
        },
        // boundaryGap: [0, '30%'],

        name: yAxisName,
        nameLocation: "middle",
        nameTextStyle: {
          color: "#4e4b66",
          fontSize: "14px",
          fontFamily: "Poppins",
        },
        nameGap: Math.max(...valueList) > 150000 ? 130 : 70,
      },
    ],

    series: [
      {
        // name: "current",
        name:
          valueList?.length === 0
            ? `FY ${compareTo}`
            : (pre_data && changeYear) || changeYear
            ? `FY ${selectYear}`
            : `FY ${compareTo}`,
        type: "line",

        symbol: "none",

        lineStyle: {
          color:
            activeTab === "sales" && changeYear
              ? "#32bc6b"
              : activeTab === "sales" && !changeYear
              ? "#7c8db0"
              : activeTab != "sales" && changeYear
              ? "#e7733e"
              : "#7c8db0",
          width: 2.5,
        },
        areaStyle: {
          opacity: 0.2,
          color:
            activeTab === "sales" && changeYear
              ? "#32bc6b"
              : activeTab === "sales" && !changeYear
              ? "#7c8db0"
              : activeTab != "sales" && changeYear
              ? "#e7733e"
              : "#7c8db0",
        },

        data:
          valueList?.length === 0
            ? valueList1
            : (pre_data && changeYear) || changeYear
            ? valueList
            : valueList1,
        // data:( Pre_data && changeYear )? valueList : (Pre_data && changeYear===false)? valueList1:[],
      },
      {
        // name: "previous",
        name: !valueList
          ? `FY ${compareTo}`
          : pre_data
          ? changeYear
            ? `FY ${compareTo}`
            : `FY ${selectYear}`
          : `FY ${selectYear}`,
        type: "line",
        // smooth: true,
        symbol: "none",

        lineStyle: {
          color:
            activeTab === "sales" && !changeYear
              ? "#32bc6b"
              : activeTab === "sales" && changeYear
              ? "#7c8db0"
              : activeTab != "sales" && !changeYear
              ? "#e7733e"
              : "#7c8db0",
          width: 2.5,
        },
        areaStyle: {
          opacity: 0.2,
          color:
            activeTab === "sales" && !changeYear
              ? "#32bc6b"
              : activeTab === "sales" && changeYear
              ? "#7c8db0"
              : activeTab != "sales" && !changeYear
              ? "#e7733e"
              : "#7c8db0",
        },
        data: !valueList
          ? valueList1
          : pre_data
          ? changeYear
            ? valueList1
            : valueList
          : [],
      },
    ],
  };
  return (
    <>
      <ReactECharts option={option} />
    </>
  );
};

export default DataGraph;
